import axios, { AxiosRequestConfig } from 'axios';
import { PagedResponse } from '../types/api';

export interface YearExperience {
  id: number;
  label: string;
  shortLabel?: string;
}

const URL = '/v2/year-experiences';

class YearExperienceService {
  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<YearExperience>> {
    return axios.get(URL, config);
  }
}

export { YearExperienceService };
